import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BlogResearchIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BlogResearch",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7 21c-.55 0-1-.45-1-1V6c0-1.65 1.35-3 3-3h12c1.65 0 3 1.35 3 3v6c0 .55-.45 1-1 1s-1-.45-1-1V6c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v14c0 .55-.45 1-1 1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13 25H7c-2.76 0-5-2.24-5-5v-8c0-.55.45-1 1-1s1 .45 1 1v8c0 1.65 1.35 3 3 3h6c.55 0 1 .45 1 1s-.45 1-1 1M19 13h-8c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1m-7-2h6V9h-6zM14 17h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13 21h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1M29 29c-.26 0-.51-.1-.71-.29l-3.62-3.62a.996.996 0 1 1 1.41-1.41l3.62 3.62a.996.996 0 0 1-.71 1.7Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.91 26.82c-3.26 0-5.91-2.65-5.91-5.91S18.65 15 21.91 15s5.91 2.65 5.91 5.91-2.65 5.91-5.91 5.91m0-9.82a3.91 3.91 0 1 0 0 7.82 3.91 3.91 0 1 0 0-7.82"
    })]
  }));
};